import { IAjaxPostConfig, AjaxPost } from "./index";

// Custom validators for Knockout Validation plugin
export class FormValidators {

    public static mustEqual(val: any, other: any): boolean {
        return val === other;
    }

    public static checkEmailExists(val: string, params?: never, callback?): boolean {

        if (!val)
            return;

        let ajaxConfig: IAjaxPostConfig = {
            backdrop: false,
            endpoint: '/Account/EmailIsValid',
            payload: JSON.stringify({ Email: val }),
            cbFunction: function (data) {
                data === 1 ? callback(true) : callback(false);
            }
        }

        let validate = new Promise((resolve, reject) => {
            return resolve(new AjaxPost(ajaxConfig));
        })

        validate.then(function () {
            return callback;
        })
    }

    public static passwordComplexity(val: string): boolean {
        return /(?=^[^\s]{6,128}$)((?=.*?\d)(?=.*?[A-Z])(?=.*?[a-z])|(?=.*?\d)(?=.*?[^\w\d\s])(?=.*?[a-z])|(?=.*?[^\w\d\s])(?=.*?[A-Z])(?=.*?[a-z])|(?=.*?\d)(?=.*?[A-Z])(?=.*?[^\w\d\s]))^.*/
            .test('' + val + '');
    }

}